{
  "title": "Không thể hoàn tất check-in của bạn",
  "message": "Không thể xác thực giấy tờ tùy thân của bạn"
}
